"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const get_string_date_1 = require("@App/helpers/get-string-date");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const UserRowPopup_1 = __importDefault(require("@Components/UserRowComponent/UserRowPopup"));
const EmailStatusBlock_1 = __importDefault(require("@Components/UserRowComponent/EmailStatusBlock"));
const UserActivityBlock_1 = __importDefault(require("@Components/UserRowComponent/UserActivityBlock"));
const UserInfoBlock_1 = __importDefault(require("@Components/UserRowComponent/UserInfoBlock"));
const UserRowComponent = (props) => {
    const { userData, onReloadData, noDots } = props;
    const [actionType, setActionType] = (0, react_1.useState)();
    const [confirmPopupIsOpen, setConfirmPopupIsOpen] = (0, react_1.useState)(false);
    const onOpenConfirmPopup = (userAction) => {
        setActionType(userAction);
        setConfirmPopupIsOpen(true);
    };
    const onCloseConfirmPopup = () => {
        setConfirmPopupIsOpen(false);
    };
    const { id, lastActivity } = userData;
    const lastActivityDateString = lastActivity ? (0, get_string_date_1.getStringDate)(lastActivity) : '';
    return (react_1.default.createElement("div", { className: "user-row-component" },
        react_1.default.createElement("div", { className: 'user-row-head' },
            react_1.default.createElement(UserInfoBlock_1.default, { userData: userData }),
            react_1.default.createElement(UserActivityBlock_1.default, { userId: id, onOpenConfirmPopup: onOpenConfirmPopup, noDots: noDots, lastActivityDateString: lastActivityDateString })),
        react_1.default.createElement(EmailStatusBlock_1.default, { userData: userData, lastActivityDateString: lastActivityDateString }),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: confirmPopupIsOpen, onClose: onCloseConfirmPopup },
            react_1.default.createElement(UserRowPopup_1.default, { userData: userData, onReloadData: onReloadData, onCloseConfirmPopup: onCloseConfirmPopup, actionType: actionType }))));
};
exports.default = UserRowComponent;
